import i18n from '@/shared/i18n';
import BaseModel from "@/core/components/input-widget/BaseModel";

export default class InventoryMiscChargeModel extends BaseModel {
  amount = null;
  description = null;
  percentage = null;
  inventory_uuid = null;
  taxable = true;
  comment = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    description: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
    amount: i18n.t('Amount'),
    description: i18n.t('Title'),
    comment: i18n.t('Comment'),
    percentage: i18n.t('Percentage'),
    inventory_uuid: i18n.t('Inventory'),
    taxable: i18n.t('Taxable'),
  };
}
